import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromQueryConfig from './query-config.reducer';

export const selectQueryConfigState = createFeatureSelector<fromQueryConfig.State>(
  fromQueryConfig.queryConfigFeatureKey
);

export const selectQueryConfigData = createSelector(
  selectQueryConfigState,
  (state: fromQueryConfig.State) => state.queryConfigData
);
